import { Box, Card, CardContent, Grid } from "@mui/material";
import _ from "lodash";
import { useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Form, Formik, FormikValues } from "formik";

import ECSubmissionSAE from "../../ECSubmission/ECSubmissionSAE";
import StudyDetailsSae from "../../StudyDetails/StudyDetailsSae";
import ProgressSteps from "../../../../common/ProgressSteps/ProgressSteps";
import CreatePageFormFooter from "../../../../common/Form/CreatePageFormFooter/CreatePageFormFooter";

import {
  EC_SUBMISSION_TYPES,
  RoutingList,
  stepsInfo,
} from "../../../../../constants";
import { logger } from "../../../../../utils/logger";
import { useCreateEcsMutation } from "../../../../../generated/graphql";
import { SaeStepValidation, StudyCloseInitData } from "../../utils";
import { formikMultiStepHandler } from "../../../../../utils/formikMultiStepFormStepHandler";
import { DocumentSubmissionDropdown } from "../../../../../types/forms/DoumentSubmission";

type StudyReportProps = {
  value: string;
};

const StudyReport = (props: StudyReportProps) => {
  const [currentStep, setCurrentStep] = useState(0);

  const navigate = useNavigate();
  const [createEcsMutation] = useCreateEcsMutation();
  const saveHandler = async (values: FormikValues) => {
    try {
      await createEcsMutation({
        variables: {
          protocolNumber: values.protocolNumber,
          micr: values.micr,
          emails: values.emails,
          isFunded: values.isFunded,
          title: values.title,
          sponsor: values.sponsor,
          principalInvestigator: values.principalInvestigator,
          coInvestigator: values.coInvestigator,
          department: values.department,
          studyPhase: values.studyPhase,
          typeOfStudy: values.typeOfStudy,
          fundType: values.fundType,
          documents: values.documents
            .filter((doc: DocumentSubmissionDropdown) => doc.url !== "")
            .map((doc: DocumentSubmissionDropdown ) => ({
              label: doc.dropdownSelectedValue ? doc.label + '(' + doc.dropdownSelectedValue + ')' : doc.label,
              url: doc.url,
              remark: doc.remark,
              // dropdownSelectedValue: doc.dropdownSelectedValue|| ''
            })),
          type: EC_SUBMISSION_TYPES.STUDY_CLOSEOUT_REPORT,
          sub_type: props.value,
        },
      });
      toast.success("EC submission created successfully!");
      navigate(RoutingList.ethics_committee.index.path);
    } catch (err) {
      toast.error(
        (err as { message: string })?.message || "Something went wrong"
      );
      logger.error(err);
    }
  };

  return (
    <Formik
      initialValues={_.cloneDeep(StudyCloseInitData)}
      validationSchema={SaeStepValidation[currentStep]}
      onSubmit={(values, { setSubmitting, setErrors, validateForm }) => {
        formikMultiStepHandler({
          validateForm,
          values,
          stepIndex:
            currentStep > stepsInfo.length - 1 ? currentStep : currentStep + 1,
          setErrors,
          steps: currentStep,
          stepsInfo,
          setSteps: setCurrentStep,
          saveHandler,
        });
      }}
    >
      <Form>
        <Card>
          <CardContent className="pd-x-30 pd-y-30">
            <Box className="mg-b-40">
              <ProgressSteps stepsInfo={stepsInfo} currentStep={currentStep} />
            </Box>
            <Grid container className="justify-content-center">
              <Grid item xs={12} md={10} lg={10}>
                {currentStep === 0 && (
                  <StudyDetailsSae type={EC_SUBMISSION_TYPES.STUDY_CLOSEOUT_REPORT} />
                )}
                {currentStep === 1 && <ECSubmissionSAE />}
                <CreatePageFormFooter
                  setSteps={setCurrentStep}
                  steps={currentStep}
                  stepsInfo={stepsInfo}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Form>
    </Formik>
  );
};

export default StudyReport;
